//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'icon-airplane',
};
